import CompraTable from './CompraTable';

export default CompraTable;
